import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

type FinancialReportTabKey = 'all' | 'settled' | 'pending'

interface FinancialReportShellProps {
  activeTab: FinancialReportTabKey
  children: React.ReactNode
}

const TAB_ITEMS: Array<{ key: FinancialReportTabKey; label: string; path: string; icon: string }> = [
  { key: 'all', label: 'รายงานการเงิน', path: '/financial-report', icon: 'fas fa-wallet' },
  { key: 'settled', label: 'ประวัติการเดิมพัน', path: '/financial-report/betting-history', icon: 'fas fa-receipt' },
  { key: 'pending', label: 'รอผลการเล่นพนัน', path: '/financial-report/pending', icon: 'fas fa-clock' },
]

const FinancialReportShell: React.FC<FinancialReportShellProps> = ({ activeTab, children }) => {
  const navigate = useNavigate()

  return (
    <div className="content pb-3">
      <div className="container">
        <div className="row px--1">
          <div className="col-12 px-1">
            <div className="bdr-5 bx-sd mb-2">
              <div className="row mx--1">
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-4 wrap justify-content-between">
                    <a
                      href="#"
                      className="txt-link-d"
                      onClick={(e) => {
                        e.preventDefault()
                        navigate('/dashboard')
                      }}
                    >
                      <i className="fas fa-chevron-left me-1" />
                      หน้าหลัก
                    </a>
                  </div>
                </div>

                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-7">
                    <div className="bdr-5 bgc-4 c-red px-2 py-1 fs-18 t-medium mb-2">
                      <i className="fas fa-wallet me-2" />
                      รายงานการเงิน
                    </div>

                    <div className="row mx--1">
                      {TAB_ITEMS.map((tab) => (
                        <div key={tab.key} className="col-12 col-md-4 px-1 mb-2">
                          <NavLink
                            to={tab.path}
                            className={`check-button w-100 ${
                              activeTab === tab.key ? 'bgc-11' : 'bgc-5'
                            } c-white`}
                          >
                            <i className={`${tab.icon} me-2`} />
                            {tab.label}
                          </NavLink>
                        </div>
                      ))}
                    </div>

                    <div className="bdr-5 bgc-4 p-2">{children}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FinancialReportShell
